import { Injectable } from '@angular/core';
import { ServiceProvider } from './service.provider';
import { DMSBaseService } from './dms.base.service';
import { ItemPagination } from 'app/modules/admin/apps/file-manager/file-manager.types';
import { Util } from 'app/models/util';
import { userStatus } from 'app/models/user';

@Injectable({ providedIn: 'root' })
export class UserService extends DMSBaseService {
  constructor(
    public provider: ServiceProvider,
    public util: Util,
  ) {
    super("/users", provider);
  }

  public saveUser(data) {
    return this.save(data);
  }

  public edit(user) {
    let data = { ...user }
    return this.update(data, `/${data.id}`);
  }

  public register(data) {
    if (data.id != null) return this.edit(data);
    return this.saveUser(data);
  }

  public getUsers(paging: ItemPagination,status?:userStatus) {

    //const accountID = this.util.getUserFromSession().id

    let method = `/me?page=${paging.page}&limit=${paging.size}`
    if(status){
      method=`${method}&status=${status}`
    }
    return this.getList(method);
  }

  public getUserById(id) {
    return this.getById(id);

  }

  searchUser(query) {
    let method = `/search/${query}`
    return this.getList(method)
  }

  public updatePassword(data) {
    return this.update(data, "/password/update");
  }

  public uploadProfilePic(file, id) {
    return this.uploadImg(file, `/${id}/profile/upload/image`);
    }

    updateDetail(detail){
      return this.update(detail, '/details')
    }

}
